import * as yup from 'yup';

export const ExitStatusResponseSchema = yup.object({
  exit_status: yup.number().defined(),
});

export type ExitStatusResponse = yup.InferType<typeof ExitStatusResponseSchema>;
